var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('EventsParallax'),_c('EventsCurrent'),_c('EventsStudy'),_c('EventsPast',{attrs:{"id":"past"}}),_c('GetInTouch',{attrs:{"id":"intouch"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }